import {
  GaGetPropertyStreamsPathParamType,
  GaGetPropertyStreamsResponseType,
} from "@intelligems/ig-types";
import { useQuery } from "@tanstack/react-query";

import { QueryOptions } from "../../types/react-query";
import { api } from "../api";
import { gaKeys } from "../queryKeys";
import { ApiRequest } from "../types/api";

export const getGaPropertyStreams = async (
  payload: ApiRequest<any, GaGetPropertyStreamsPathParamType>
): Promise<GaGetPropertyStreamsResponseType> => {
  const resp = await api.get<GaGetPropertyStreamsResponseType>(
    `/v2/integrations/google/ga/${payload.pathParams.accountId}/${payload.pathParams.propertyId}/streams`
  );
  return resp.data;
};
export const useGetGaPropertyStreams = (
  enabled: boolean,
  payload: ApiRequest<any, GaGetPropertyStreamsPathParamType>,
  options?: QueryOptions<GaGetPropertyStreamsResponseType, Error>
) => {
  return useQuery<GaGetPropertyStreamsResponseType, Error>({
    ...options,
    queryKey: gaKeys.streams(
      payload.pathParams.accountId!,
      payload.pathParams.propertyId!
    ),
    queryFn: async () => getGaPropertyStreams(payload),
    enabled:
      enabled &&
      payload.pathParams.accountId !== "" &&
      payload.pathParams.propertyId !== "",
    meta: {
      onError: {
        401: "ignore",
      },
    },
  });
};
